import { FunctionComponent } from 'react';
import { Container } from '@mui/material';
import CollectionWizard from 'components/collection/wizard/CollectionWizard';
import { useNavigate } from 'react-router-dom'


const GettingStarted: FunctionComponent = () => {
  const navigate = useNavigate()

  return (
    <Container maxWidth="md">
      <CollectionWizard
        cancelled={() => navigate(-1)}
        firstBackText="Cancel"
        saveLocally={true}
        onFinished={() => navigate("/")}
        finishedText='Sign Up'
        title="Start Collecting Now!"
        subtitle=""/>
    </Container>);
}

export default GettingStarted;